import { useEffect } from "react";
import * as pc from "playcanvas";
import { useAssetLoader } from "hooks/playcanvas/asset-loader";
import { useAppDispatch, actions } from "store";
import { tubeConnectionModels, tubeConnectionMaterialAreaName, tubeMaterials, tubeConnectionPlaceholderIconSize, } from "3d/constants/common";
import { createIconBillboard } from "3d/icon-billboard";
import { greyVacuumPumpIconColors } from "ui/components/elements/icons/vacuum-pump";
import { tubeConnectionIconDataUrl } from "ui/components/elements/icons/tube-connection";
var TUBE_CONNECTION_ENTITY_NAME = "TubeConnection";
var TUBE_CONNECTION_PLACEHOLDER_ENTITY_NAME = "TubeConnectionPlaceholder";
/* Raster size of the placeholder icon texture; the icon is a 43-unit SVG. */
var TUBE_CONNECTION_PLACEHOLDER_ICON_PX = 256;
export var TubeConnection = function (_a) {
    var app = _a.app, nodeEntity = _a.nodeEntity, tubeConnection = _a.tubeConnection, modelAssets = _a.modelAssets, materialAssets = _a.materialAssets;
    var loadAssets = useAssetLoader(app).loadAssets;
    var dispatch = useAppDispatch();
    /* No connection type picked yet: the node is a placeholder (see
     * `selectTubeConnectionPlaceholders`). */
    var connectionType = tubeConnection.type;
    /* Placeholder: the toolbar's "Add tube connection" icon in grey on a
     * camera-facing square, as for a pump with no pump picked, and no tube
     * attachments until there is a connection type to attach them to. */
    useEffect(function () {
        if (connectionType)
            return;
        var placeholder = createIconBillboard(app, {
            name: TUBE_CONNECTION_PLACEHOLDER_ENTITY_NAME,
            imageUrl: tubeConnectionIconDataUrl(TUBE_CONNECTION_PLACEHOLDER_ICON_PX, greyVacuumPumpIconColors),
            size: tubeConnectionPlaceholderIconSize,
        });
        nodeEntity.addChild(placeholder.entity);
        dispatch(actions.setNodeAttachments({
            nodeId: tubeConnection.nodeId,
            placeholders: [],
        }));
        return function () {
            placeholder.destroy();
        };
    }, [connectionType, app, nodeEntity, dispatch, tubeConnection.nodeId]);
    useEffect(function () {
        if (!connectionType)
            return;
        var tubeConnectionEntity = new pc.Entity(TUBE_CONNECTION_ENTITY_NAME);
        tubeConnectionEntity.addComponent("model", { type: "asset" });
        var scale = tubeConnectionModels[connectionType].type === "distribution-block"
            ? 1
            : 0.5;
        tubeConnectionEntity.setLocalScale(scale, scale, scale);
        nodeEntity.addChild(tubeConnectionEntity);
        return function () {
            tubeConnectionEntity.destroy();
        };
    }, [nodeEntity, connectionType]);
    useEffect(function () {
        if (!connectionType)
            return;
        var tubeConnectionEntity = nodeEntity.findByName(TUBE_CONNECTION_ENTITY_NAME);
        var tubeConnectionModel = tubeConnectionModels[connectionType];
        var tubeConnectionAsset = modelAssets[tubeConnectionModel.modelName];
        var updateTubeConnection = function () {
            if (tubeConnectionEntity && tubeConnectionEntity.model) {
                var hasNewAsset = tubeConnectionEntity.model.asset !== tubeConnectionAsset.id;
                // TODO: Figure out why we need to set the model asset to 0 for some inexplicable reason.
                // Currently the materials on the object won't change when applying transforms if we don't do this first.
                tubeConnectionEntity.model.asset = 0;
                tubeConnectionEntity.model.asset = tubeConnectionAsset;
                if (hasNewAsset) {
                    dispatch(actions.setNodeAttachments({
                        nodeId: tubeConnection.nodeId,
                        placeholders: tubeConnectionModel.placeholderNames.map(function (name) { return ({
                            name: name,
                            tubeType: tubeConnection.tubeType,
                        }); }),
                    }));
                }
                tubeConnectionEntity.model.meshInstances.forEach(function (meshInstance) {
                    if (meshInstance.material.name === tubeConnectionMaterialAreaName) {
                        meshInstance.material =
                            materialAssets[tubeMaterials[tubeConnection.tubeType][0]].resource;
                    }
                });
            }
        };
        loadAssets([tubeConnectionAsset], updateTubeConnection);
    }, [
        nodeEntity,
        connectionType,
        modelAssets,
        tubeConnection.tubeType,
        materialAssets,
        dispatch,
        loadAssets,
        tubeConnection.nodeId,
    ]);
    return null;
};
